import Vue from 'vue'
import Vuex from 'vuex'
import { getOutBoundList, getOutBoundDetail, getOrderDetail, getReturnDetail, getReturnList, getRefundList, delReturn, delRefund, getRefundInfo, getSubmitInfo, submitReturn, offReturn, offRefund, submitRefund } from '../../../fetch/order'
Vue.use(Vuex)
export const types = {
  /**
   * 发货单列表
   */
  GET_OUTBOUND_LIST: 'GET_OUTBOUND_LIST',
  /**
   * 发货单详情
   */
  GET_OUTBOUND_DETAIL: 'GET_OUTBOUND_DETAIL',
  /**
   * 订单详情
   */
  GET_ORDER_DETAIL: 'GET_ORDER_DETAIL',
  /**
   * 退货列表
   */
  GET_RETURN_LIST: 'GET_RETURN_LIST',
  /**
   * 删除退货详情
   */
  DELETE_RETURN: 'DELETE_RETURN',
  /**
   * 关闭退货申请
   */
  OFF_RETURN: 'OFF_RETURN',
  /**
  * 退货详情
  */
  GET_RETURN_DETAIL: 'GET_RETURN_DETAIL',
  /**
   * 退款列表
   */
  GET_REFUND_LIST: 'GET_REFUND_LIST',
  /**
   * 删除退款详情
   */
  DELETE_REFUND: 'DELETE_REFUND',
  /**
   * 退款详情
   */
  GET_REFUND_INFO: 'GET_REFUND_INFO',
  /**
   * 提交页数据
   */
  GET_SUBMIT_INFO: 'GET_SUBMIT_INFO',
  /**
   * 提交退货
   */
  SUBMIT_RETURN: 'SUBMIT_RETURN',
  /**
   * 关闭退款申请
   */
  OFF_REFUND: 'OFF_REFUND',
  /**
   * 提交退款
   */
  SUBMIT_REFUND: 'SUBMIT_REFUND'
}
export default {
  state: {
    [types.GET_OUTBOUND_LIST]: {},
    [types.GET_OUTBOUND_DETAIL]: {},
    [types.GET_ORDER_DETAIL]: {},
    [types.GET_RETURN_LIST]: {},
    [types.GET_RETURN_DETAIL]: {},
    [types.DELETE_RETURN]: {},
    [types.GET_REFUND_LIST]: {},
    [types.DELETE_REFUND]: {},
    [types.GET_REFUND_INFO]: {},
    [types.GET_SUBMIT_INFO]: {},
    [types.SUBMIT_RETURN]: {},
    [types.OFF_RETURN]: {},
    [types.OFF_REFUND]: {},
    [types.SUBMIT_REFUND]: {}
  },
  mutations: {
    [types.GET_OUTBOUND_LIST]: (state, res) => {
      state[types.GET_OUTBOUND_LIST] = res
    },
    [types.GET_OUTBOUND_DETAIL]: (state, res) => {
      state[types.GET_OUTBOUND_DETAIL] = res
    },
    [types.GET_ORDER_DETAIL]: (state, res) => {
      state[types.GET_ORDER_DETAIL] = res
    },
    [types.GET_RETURN_LIST]: (state, res) => {
      state[types.GET_RETURN_LIST] = res
    },
    [types.GET_RETURN_DETAIL]: (state, res) => {
      state[types.GET_RETURN_DETAIL] = res
    },
    [types.DELETE_RETURN]: (state, res) => {
      state[types.DELETE_RETURN] = res
    },
    [types.GET_REFUND_LIST]: (state, res) => {
      state[types.GET_REFUND_LIST] = res
    },
    [types.DELETE_REFUND]: (state, res) => {
      state[types.DELETE_REFUND] = res
    },
    [types.GET_REFUND_INFO]: (state, res) => {
      state[types.GET_REFUND_INFO] = res
    },
    [types.GET_SUBMIT_INFO]: (state, res) => {
      state[types.GET_SUBMIT_INFO] = res
    },
    [types.SUBMIT_RETURN]: (state, res) => {
      state[types.SUBMIT_RETURN] = res
    },
    [types.OFF_RETURN]: (state, res) => {
      state[types.OFF_RETURN] = res
    },
    [types.OFF_REFUND]: (state, res) => {
      state[types.OFF_REFUND] = res
    },
    [types.SUBMIT_REFUND]: (state, res) => {
      state[types.SUBMIT_REFUND] = res
    }
  },
  actions: {
    [types.GET_OUTBOUND_LIST]: async ({ commit }, params) => {
      const res = await getOutBoundList(params)
      return commit(types.GET_OUTBOUND_LIST, res)
    },
    [types.GET_OUTBOUND_DETAIL]: async ({ commit }, params) => {
      const res = await getOutBoundDetail(params)
      return commit(types.GET_OUTBOUND_DETAIL, res)
    },
    [types.GET_ORDER_DETAIL]: async ({ commit }, params) => {
      const res = await getOrderDetail(params)
      return commit(types.GET_ORDER_DETAIL, res)
    },
    [types.GET_RETURN_LIST]: async ({ commit }, params) => {
      const res = await getReturnList(params)
      return commit(types.GET_RETURN_LIST, res)
    },
    [types.GET_RETURN_DETAIL]: async ({ commit }, params) => {
      const res = await getReturnDetail(params)
      return commit(types.GET_RETURN_DETAIL, res)
    },
    [types.DELETE_RETURN]: async ({ commit }, params) => {
      const res = await delReturn(params)
      return commit(types.DELETE_RETURN, res)
    },
    [types.GET_REFUND_LIST]: async ({ commit }, params) => {
      const res = await getRefundList(params)
      return commit(types.GET_REFUND_LIST, res)
    },
    [types.DELETE_REFUND]: async ({ commit }, params) => {
      const res = await delRefund(params)
      return commit(types.DELETE_REFUND, res)
    },
    [types.GET_REFUND_INFO]: async ({ commit }, params) => {
      const res = await getRefundInfo(params)
      return commit(types.GET_REFUND_INFO, res)
    },
    [types.GET_SUBMIT_INFO]: async ({ commit }, params) => {
      const res = await getSubmitInfo(params)
      return commit(types.GET_SUBMIT_INFO, res)
    },
    [types.SUBMIT_RETURN]: async ({ commit }, params) => {
      const res = await submitReturn(params)
      return commit(types.SUBMIT_RETURN, res)
    },
    [types.OFF_RETURN]: async ({ commit }, params) => {
      const res = await offReturn(params)
      return commit(types.OFF_RETURN, res)
    },
    [types.OFF_REFUND]: async ({ commit }, params) => {
      const res = await offRefund(params)
      return commit(types.OFF_REFUND, res)
    },
    [types.SUBMIT_REFUND]: async ({ commit }, params) => {
      const res = await submitRefund(params)
      return commit(types.SUBMIT_REFUND, res)
    }
  },
  getters: {
    getBoundList (state) {
      return state[types.GET_OUTBOUND_LIST]
    },
    getBoundDetail (state) {
      return state[types.GET_OUTBOUND_DETAIL]
    },
    getOrderDetail (state) {
      return state[types.GET_ORDER_DETAIL]
    },
    getReturnList (state) {
      return state[types.GET_RETURN_LIST]
    },
    getReturnDetail (state) {
      return state[types.GET_RETURN_DETAIL]
    },
    deleteReturn (state) {
      return state[types.DELETE_RETURN]
    },
    getRefundList (state) {
      return state[types.GET_REFUND_LIST]
    },
    getRefundDetail (state) {
      return state[types.GET_REFUND_DETAIL]
    },
    deleteRefund (state) {
      return state[types.DELETE_REFUND]
    },
    getRefundInfo (state) {
      return state[types.GET_REFUND_INFO]
    },
    getSubmitInfo (state) {
      return state[types.GET_SUBMIT_INFO]
    },
    submitReturn (state) {
      return state[types.SUBMIT_RETURN]
    },
    offReturn (state) {
      return state[types.OFF_RETURN]
    },
    offRefund (state) {
      return state[types.OFF_REFUND]
    },
    submitRefund (state) {
      return state[types.SUBMIT_REFUND]
    }
  }
}
